import { COLOR, FONT_SIZE, FONT_WEIGHT, mq, Icon as _Icon } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

const CUSTOM_BLACK_POINT = {
  middle: "@media (max-width: 840px)",
  pc: "@media (max-width: 1024px)",
};

export const DivContainer = styled.div`
  width: 100%;
  padding: 16px 32px;

  ${CUSTOM_BLACK_POINT.middle} {
    padding: 8px 16px;
  }
`;

export const DivActionButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  background-color: ${COLOR.GRAY200.code};

  ${CUSTOM_BLACK_POINT.pc} {
    flex-wrap: wrap;
  }

  ${CUSTOM_BLACK_POINT.middle} {
    flex-direction: column;
  }

  ${mq.sp} {
    padding: 16px 0px;
  }
`;

export const AnchorPurchase = styled.a`
  ${CUSTOM_BLACK_POINT.pc} {
    margin-top: 16px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  width: 240px;
  height: 48px;
  border-radius: 50px;
  background-color: ${COLOR.YELLOW50.code};
  color: ${COLOR.GRAY50.code};
  font-weight: ${FONT_WEIGHT.BOLD};

  ${mq.sp} {
    width: 240px;
    height: 40px;
    font-size: ${FONT_SIZE.S}px;
    margin-top: 8px;
  }
`;

export const DivSummaryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mq.sp} {
    padding: 0;
  }
`;

export const ParSummary = styled.p`
  text-align: center;
  white-space: nowrap;
  font-family: hiragino sans;
  font-weight: 800;
  font-size: ${FONT_SIZE.M + 2}px;

  ${mq.sp} {
    display: none;
  }
`;

export const SpanSPSummary = styled.span`
  display: none;
  font-family: hiragino sans;
  ${mq.sp} {
    display: inline-block;
    font-weight: 800;
    font-size: ${FONT_SIZE.M + 2}px;
  }
`;

export const ParSubSummary = styled.p`
  font-family: hiragino sans;
  text-align: center;
  white-space: nowrap;
  font-size: ${FONT_SIZE.XS}px;
  color: ${COLOR.GRAY900.code};
  font-weight: ${FONT_WEIGHT.NORMAL};
  margin-top: 4px;

  ${mq.sp} {
    display: none;
  }
`;

export const SpanSPSubSummary = styled.span`
  display: none;
  font-family: hiragino sans;
  ${mq.sp} {
    display: inline-block;
    font-size: ${FONT_SIZE.XS}px;
    color: ${COLOR.GRAY900.code};
    font-weight: ${FONT_WEIGHT.NORMAL};
  }
`;

export const ParSummaryWrapper = styled.p<{ marginTop?: number }>`
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: ${({ marginTop }) => marginTop ?? 0}px;
  font-family: hiragino sans;
`;

export const DivIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid ${COLOR.GRAY500.code};
  height: 48px;
  padding-right: 16px;
  margin-right: 16px;

  ${CUSTOM_BLACK_POINT.middle} {
    border-right: 0px;
    padding: 0;
    margin-right: 0px;
    height: auto;
  }
`;

export const Icon = styled(_Icon)`
  svg {
    height: 40px;
    width: auto;

    ${mq.sp} {
      height: 36px;
    }
  }
`;
